import type { MailboxInfo } from "owa-client-types";
import { isMessageFileMailboxInfo } from "owa-client-types/lib/MessageFileMailboxInfo";
import { ClientIdPrefix } from "owa-identifiers";
import type Item from "owa-service/lib/contract/Item";

// Item ids of locally parsed .msg files are prefixed with this value and are not server ids
const MESSAGE_FILE_ID_PREFIX = "fileId:";

// Mirrors the item classes the meetingContentFromConversation service rejects.
// An item class matches when it equals one of these or starts with '<class>.'
const UNSUPPORTED_MEETING_ITEM_CLASSES = [
    "ipm.schedule.meeting",
    "ipm.notification.meeting",
    "ipm.note.reminder.event",
];

const UNSUPPORTED_AUTOMATIC_REPLY_ITEM_CLASSES = [
    "ipm.note.rules.ooftemplate.microsoft",
    "ipm.note.rules.externalooftemplate.microsoft",
];

/**
 * Whether the Copilot variant of reply with meeting ("Schedule with Copilot") can generate
 * meeting content for the given item. Returns false for items the meetingContentFromConversation
 * service always rejects, so callers can disable the Copilot entry point or fall back to the
 * non-Copilot reply with meeting experience.
 * Encrypted (IRM) items are intentionally not gated because the client can't reliably detect
 * which items the service rejects.
 */
export function isScheduleWithCopilotSupportedForItem(item: Item | undefined, mailboxInfo?: MailboxInfo): boolean {
    if (!item) {
        return true;
    }
    
    const itemClass = item.ItemClass?.toLowerCase();
    if (itemClass) {
        const isMeetingItemClass = UNSUPPORTED_MEETING_ITEM_CLASSES.some(unsupportedClass => itemClass === unsupportedClass || itemClass.startsWith(unsupportedClass + "."));
        if (isMeetingItemClass || UNSUPPORTED_AUTOMATIC_REPLY_ITEM_CLASSES.includes(itemClass)) {
            return false;
        }
    }
    
    if (isMessageFileMailboxInfo(mailboxInfo)) {
        return false;
    }
    
    const itemId = item.ItemId?.Id;
    if (itemId &&
        (itemId.startsWith(MESSAGE_FILE_ID_PREFIX) || itemId.startsWith(ClientIdPrefix))) {
        return false;
    }
    
    return true;
}
